module.exports = __webpack_public_path__ + "media/common/images/badges/active/dotahovac_2-3be97c9a65b51de38c6f3719d179f403.svg";